module.exports = __webpack_public_path__ + "static/media/cert.c3d32703.jpg";